define('SageDotCom/Components/Content/IntacctResourcesCentre/IntacctResourceCentre',[
    "jquery",
    "text!SageDotCom/Components/Templates/IntacctResourceCard.html"
], function ($, _cardTemplate) {

    function IntacctResourceCentre(scope, data, desktopCount, mobileCount) {
        Object.defineProperty(this, "scope", { enumerable: true, value: scope, writable: !1 });
        Object.defineProperty(this, "$scope", { enumerable: !0, value: $(scope) });

        const resourcesListings = $(scope).find(".intacct-resources-listings");
        let intacctContainer = resourcesListings.find(".intacct-resources");
        const isMobile = intacctContainer.hasClass("is-mobile");
        const numberToShow = isMobile ? mobileCount : desktopCount;

        let intacctResourceCardTemplate = _.template(_cardTemplate);
        let html = "";
        for (let i = 0; i < numberToShow && i < data.length; i++) {
            html += intacctResourceCardTemplate(data[i]);
        }
        intacctContainer.html(html);
    };

    function truncate(str, length) {
        if (str.length > length) {
          return str.slice(0, length) + '...';
        } else return str;
      }

    IntacctResourceCentre.init = function (args) {
        return new IntacctResourceCentre(args.scope, args.data, args.desktopCount, args.mobileCount);
    };

    return IntacctResourceCentre;

});
